import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    return window.localStorage.getItem("latir-lang") || "es";
  });

  const changeLang = useCallback((next) => {
    setLang(next);
    try {
      window.localStorage.setItem("latir-lang", next);
      document.documentElement.lang = next;
    } catch (e) {
      /* noop */
    }
  }, []);

  const toggleLang = useCallback(() => {
    changeLang(lang === "es" ? "en" : "es");
  }, [lang, changeLang]);

  const t = useCallback(
    (key) => translations[lang]?.[key] ?? translations.es[key] ?? key,
    [lang]
  );

  // pick a bilingual field from a data object: tf(artist.title)
  const tf = useCallback((field) => (field ? field[lang] ?? field.es : ""), [lang]);

  const value = useMemo(
    () => ({ lang, setLang: changeLang, toggleLang, t, tf }),
    [lang, changeLang, toggleLang, t, tf]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
